import React from 'react';

import FormikInput from "components/input/new/FormikInput";

function CustomerNumber(props) {
    return (
        <FormikInput
            name={'additionalData.carrierServiceId'}
            label={'shippingMethods.form.field.additionalData.carrierServiceId.label'}
            placeholder={'shippingMethods.form.field.additionalData.carrierServiceId.placeholder'}
            required={true}
        />
    );
}

export default CustomerNumber;
